import type { StoredCreativeImportRun } from '../types/creative-import.types';

const STORAGE_PREFIX = 'creative-import-run:';

function storageKey(clientId: string): string {
  return `${STORAGE_PREFIX}${clientId}`;
}

export function getStoredCreativeImportRun(clientId: string): StoredCreativeImportRun | null {
  if (typeof localStorage === 'undefined' || !clientId) {
    return null;
  }

  const raw = localStorage.getItem(storageKey(clientId));
  if (!raw) {
    return null;
  }

  try {
    const parsed = JSON.parse(raw) as StoredCreativeImportRun;
    if (!parsed?.runId || parsed.clientId !== clientId) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function storeCreativeImportRun(run: StoredCreativeImportRun): void {
  if (typeof localStorage === 'undefined' || !run.clientId || !run.runId) {
    return;
  }
  localStorage.setItem(storageKey(run.clientId), JSON.stringify(run));
}

export function clearStoredCreativeImportRun(clientId: string): void {
  if (typeof localStorage === 'undefined' || !clientId) {
    return;
  }
  localStorage.removeItem(storageKey(clientId));
}
